import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentTermsListAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllShipmentTerms`,
    method: 'get',
  });
};

export type ShipmentTermsResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentTerms = async (): Promise<ShipmentTermsResponse> => {
  const response: AxiosResponse<ShipmentTermsResponse> = await getShipmentTermsListAPI();
  return response.data;
};
